module.exports = __webpack_public_path__ + "static/media/loading.79d41618.svg";